import { AppSettings } from '../configs';
import { authHeader } from '../helpers/auth-header';
import axios  from "../utils/axios";



const AdjustmentService = {};

AdjustmentService.searchReportAction = (serachCondition) => {
    
    return new Promise((resolve, reject) => {
        axios({
          headers: {...authHeader(),'Pragma': 'no-cache'},
          method: "post",
          url: `${AppSettings.apiUrl}/api/Adjustment/GetAdjustment`,
          data: serachCondition
        })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })

}

AdjustmentService.getAdjustmentById = (adjustment_id) => {

  return new Promise((resolve, reject) => {
    axios({
      headers: { ...authHeader(), 'Pragma': 'no-cache' },
      method: "get",
      url: `${AppSettings.apiUrl}/api/Adjustment/GetAdjustmentById`,
      params: {
        adjustment_id: adjustment_id
      }
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error))
  })

}

AdjustmentService.searchPoContractNo = (poContractNo) => {

  return new Promise((resolve, reject) => {
    axios({
      headers: { ...authHeader(), 'Pragma': 'no-cache' },
      method: "get",
      url: `${AppSettings.apiUrl}/api/Adjustment/SearchPoContractNo`,
      params: {
        poContractNo: poContractNo
      }
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error))
  })

}

AdjustmentService.saveAdjustment = (objAdjustment) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "post",
        url: `${AppSettings.apiUrl}/api/Adjustment/SaveAdjustment`,
        data: objAdjustment
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })

}

AdjustmentService.updateAdjustment = (objAdjustment) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "post",
        url: `${AppSettings.apiUrl}/api/Adjustment/UpdateAdjustment`,
        data: objAdjustment
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })

}

AdjustmentService.updateEditAdjustment = (objAdjustment) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "post",
        url: `${AppSettings.apiUrl}/api/Adjustment/UpdateEditAdjustment`,
        data: objAdjustment
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })

}

AdjustmentService.getAdjustmentFormMaster = () => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "get",
        url: `${AppSettings.apiUrl}/api/Adjustment/GetAdjustmentFormMaster`,
        data: {}
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error))
    })

}


AdjustmentService.getDraftPDFFile = ({id,type,filename,template,body,title,values}) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "post",
        url: `${AppSettings.apiUrl}/api/Report/CreatePDFDraft`,
        responseType: 'blob',
        ContentType: 'application/json; charset=UTF-8',
        Accept: 'application/json',
        data: {'id':id,
        'type':type,
        'template_code':template,
        'body':body,
        'title':title,
        'values':values}
      })
        .then(result => {

          try {
            const { data } = result;
      
            if (window.navigator.msSaveOrOpenBlob) {
              const link = document.createElement('a');
              document.body.appendChild(link);
              link.style.display = "none";
      
              link.onclick = ((evx) => {
                var newBlob = new Blob([new Uint8Array(result.response)]);
                window.navigator.msSaveOrOpenBlob(data, `${filename}.pdf`);
              });
              link.click();
              link.remove();
            } else {
              const downloadUrl = window.URL.createObjectURL(new Blob([data]))
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', `${filename}.pdf`);
              document.body.appendChild(link);
              link.click()
              link.remove()
            }
      
          } catch (e) {
      
          }
          resolve(result.data)
        })
        .catch(error => reject(error))
    })
}

AdjustmentService.getPDFFile = ({id,type,filename,template,body,title,values}) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "post",
        url: `${AppSettings.apiUrl}/api/Report/CreatePDF`,
        responseType: 'blob',
        ContentType: 'application/json; charset=UTF-8',
        Accept: 'application/json',
        data: {'id':id,
        'type':type,
        'template_code':template,
        'body':body,
        'title':title,
        'values':values}
      })
        .then(result => {

          try {
            const { data } = result;
      
            if (window.navigator.msSaveOrOpenBlob) {
              const link = document.createElement('a');
              document.body.appendChild(link);
              link.style.display = "none";
      
              link.onclick = ((evx) => {
                var newBlob = new Blob([new Uint8Array(result.response)]);
                window.navigator.msSaveOrOpenBlob(data, `${filename}.pdf`);
              });
              link.click();
              link.remove();
            } else {
              const downloadUrl = window.URL.createObjectURL(new Blob([data]))
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', `${filename}.pdf`);
              document.body.appendChild(link);
              link.click()
              link.remove()
            }
      
          } catch (e) {
      
          }
          resolve(result.data)
        })
        .catch(error => reject(error))
    })
}


AdjustmentService.getCreatePDFAdjustmentDetail = ({id,type,filename,template,body,title}) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "post",
        url: `${AppSettings.apiUrl}/api/Report/CreatePDFAdjustmentDetail`,
        responseType: 'blob',
        ContentType: 'application/json; charset=UTF-8',
        Accept: 'application/json',
        data: {
              'id':id,
              'type':type,
              'template_code':template,
              'body':body,
              'title':title}
      })
        .then(result => {

          try {
            const { data } = result;
      
            if (window.navigator.msSaveOrOpenBlob) {
              const link = document.createElement('a');
              document.body.appendChild(link);
              link.style.display = "none";
      
              link.onclick = ((evx) => {
                var newBlob = new Blob([new Uint8Array(result.response)]);
                window.navigator.msSaveOrOpenBlob(data, `${filename}.pdf`);
              });
              link.click();
              link.remove();
            } else {
              const downloadUrl = window.URL.createObjectURL(new Blob([data]))
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', `${filename}.pdf`);
              document.body.appendChild(link);
              link.click()
              link.remove()
            }
      
          } catch (e) {
      
          }
          resolve(result.data)
        })
        .catch(error => reject(error))
    })
}


AdjustmentService.getPDFLink = ({url, filename}) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "get",
        url: `${url}`,
        responseType: 'blob',
        ContentType: 'application/json; charset=UTF-8',
        Accept: 'application/json',
        data: {}
      })
        .then(result => {

          try {
            const { data } = result;
      
            if (window.navigator.msSaveOrOpenBlob) {
              const link = document.createElement('a');
              document.body.appendChild(link);
              link.style.display = "none";
      
              link.onclick = ((evx) => {
                var newBlob = new Blob([new Uint8Array(result.response)]);
                window.navigator.msSaveOrOpenBlob(data, `${filename}.pdf`);
              });
              link.click();
              link.remove();
            } else {
              const downloadUrl = window.URL.createObjectURL(new Blob([data]))
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', `${filename}.pdf`);
              document.body.appendChild(link);
              link.click()
              link.remove()
            }
      
          } catch (e) {
      
          }
          resolve(result.data)
        })
        .catch(error => reject(error))
    })
}


AdjustmentService.getCreatePDFMomAdjustmentDetail = ({id,type,filename,template,body,title, transaction_no}) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "post",
        url: `${AppSettings.apiUrl}/api/Report/CreatePDFAdjustmentDetail`,
        responseType: 'blob',
        ContentType: 'application/json; charset=UTF-8',
        Accept: 'application/json',
        data: {
              'id':id,
              'type':type,
              'template_code':template,
              'body':body,
              'title':title,
            'transaction_no': transaction_no}
      })
        .then(result => {

          try {
            const { data } = result;
      
            if (window.navigator.msSaveOrOpenBlob) {
              const link = document.createElement('a');
              document.body.appendChild(link);
              link.style.display = "none";
      
              link.onclick = ((evx) => {
                var newBlob = new Blob([new Uint8Array(result.response)]);
                window.navigator.msSaveOrOpenBlob(data, `${filename}.pdf`);
              });
              link.click();
              link.remove();
            } else {
              const downloadUrl = window.URL.createObjectURL(new Blob([data]))
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', `${filename}.pdf`);
              document.body.appendChild(link);
              link.click()
              link.remove()
            }
      
          } catch (e) {
      
          }
          resolve(result.data)
        })
        .catch(error => reject(error))
    })
}



AdjustmentService.getSearchAdjustmentNo = (adjust_type, po_contract_no) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "get",
        url: `${AppSettings.apiUrl}/api/Adjustment/SearchAdjustmentNo/${adjust_type}/${po_contract_no}`,
        data: {}
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error))
    })

}


AdjustmentService.getMasterConfig = (master_code) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "get",
        url: `${AppSettings.apiUrl}/api/Master/GetMasterConfig/${master_code}`,
        data: {}
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error))
    })
}

AdjustmentService.getMasterConfigs = (master_codes) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "get",
        url: `${AppSettings.apiUrl}/api/Master/GetMasterConfigs/${master_codes}`,
        data: {}
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error))
    })
}

AdjustmentService.getMaster = (key) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "get",
        url: `${AppSettings.apiUrl}/api/Master/GetMaster`,
        params: { key: key}
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error))
    })
}

AdjustmentService.getNextDayWithoutWeekEndAndHoliday = (date, day)=>{
  
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "get",
        url: `${AppSettings.apiUrl}/api/Master/GetNextDayWithoutWeekEndAndHoliday`,
        params: {
          date: date,
          day: day
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

// url: `${AppSettings.apiUrl}/api/ReportReceipt/GetReportReceiptVendor`,
export default AdjustmentService;